namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_presence_cursor, {
		
		position: 'absolute',

		Icon: {
			padding: 0,
			width: '1.5rem',
			height: '1.5rem',
			margin: {
				top: '-1px',
				left: '-6px',
			},
		},

		Name: {
			padding: {
				top: $mol_gap.block,
				left: $mol_gap.space,
			},
		},

		pointerEvents: 'none',
		transition: 'top 0.2s, left 0.2s',
		
	} )
	
}
